import { render, staticRenderFns } from "./InfoTrackerForm.vue?vue&type=template&id=3964b78f"
import script from "./InfoTrackerForm.vue?vue&type=script&lang=js"
export * from "./InfoTrackerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports